import { APP_AMOUNT_LOCALE } from './constants';

/**
 * Formatowanie kwoty
 */
export const formatAmount = `return value && value.toLocaleString("${APP_AMOUNT_LOCALE}", {minimumFractionDigits: 2, maximumFractionDigits: 2})`;
